import type { BlockType } from 'shared-types';
import type { ReduxRootState } from 'types';

type BlockTypes = BlockType | 'embed' | 'singlechoice' | 'task';

// overloads
function getBlockNameByType({
  messages,
  type
}: {
  messages: ReduxRootState['messages'];
  type: BlockTypes;
}): string;
function getBlockNameByType({
  messages,
  type
}: {
  messages: ReduxRootState['messages'];
  type?: never;
}): Record<BlockTypes, string>;

// implementation
function getBlockNameByType({
  messages,
  type
}: {
  messages: ReduxRootState['messages'];
  type?: BlockTypes;
}) {
  const nameByBlockType = {
    audio: messages.blocksAudio,
    discussion: messages.blocksDiscussion,
    embed: messages.blocksEmbed,
    embedcode: messages.blocksEmbedCode,
    embedlink: messages.blocksEmbedLink,
    file: messages.commonFile,
    fillin: messages.blocksFillIn,
    h5p: messages.blocksH5P,
    heading: messages.blocksHeading,
    image: messages.blocksImage,
    likert: messages.blocksLikert,
    list: messages.blocksList,
    mathjax: messages.blocksMath,
    multiplechoice: messages.blocksMultipleChoice,
    numericquestion: messages.blocksNumericQuestion,
    openquestion: messages.blocksOpenQuestion,
    pagebreak: messages.blocksPageBreak,
    pre: messages.blocksPre,
    quote: messages.blocksQuote,
    raw: messages.blocksRaw,
    scorm: messages.blocksScorm,
    sequencing: messages.blocksSequencing,
    singlechoice: messages.blocksSingleChoice,
    table: messages.blocksTable,
    task: messages.commonTask,
    text: messages.blocksText,
    video: messages.blocksVideo
  };

  return type ? nameByBlockType[type] : nameByBlockType;
}

export default getBlockNameByType;
